// Libraries
import { CSSProperties } from "react";

// Contexts
import { useLeadsContext } from "@/DataPages/context/crm/LeadsContext";

// Components
import { Box, Grid, Typography } from "@mui/material";
import LabeledFormInput from "@/Layouts/components/SmartAddressFormSection/LabeledFormInput";
import SimpleTextField from "@/Layouts/components/InputComponents/SimpleTextField";

// Constants
import { REQUIRED_FIELD_CLASSES } from "../../../constants";

// Helpers
import { isIndividual } from "../../../helpers";

type TCustomerNameSectionProps = {
	sx?: CSSProperties;
	className?: string;
	firstInputLabel: string;
	secondInputLabel: string;
	thirdInputLabel: string;
};

export function CustomerNameSection(props: Readonly<TCustomerNameSectionProps>) {
	const { sx, className, firstInputLabel, secondInputLabel, thirdInputLabel } = props ?? {};

	const { isSavingLead, getContextValue, getContextError, onChangeContext } = useLeadsContext();

	return (
		<Box sx={sx} className={className}>
			<Typography className="!font-montserrat !font-[500] !text-[16px] !text-gray-text !mb-3">Name</Typography>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={4} sx={{ position: "relative" }}>
					<LabeledFormInput
						label={firstInputLabel}
						formInput={
							<SimpleTextField
								editable
								outlined
								text={getContextValue("customer", "firstInputName")}
								placeholder={firstInputLabel}
								error={getContextError("customer", "firstInputName")}
								classes={getContextError("customer", "firstInputName") ? REQUIRED_FIELD_CLASSES : ""}
								onFocusOut={(value = "") => onChangeContext<string>("customer", "firstInputName", value)}
								disabled={isSavingLead}
								inputProps={{ maxLength: isIndividual(getContextValue("customer", "type")) ? 30 : 35 }}
							/>
						}
					/>
				</Grid>

				<Grid item xs={12} sm={4}>
					<LabeledFormInput
						label={secondInputLabel}
						formInput={
							<SimpleTextField
								editable
								outlined
								text={getContextValue("customer", "secondInputName")}
								placeholder={secondInputLabel}
								error={getContextError("customer", "secondInputName")}
								onFocusOut={(value = "") => onChangeContext<string>("customer", "secondInputName", value)}
								disabled={isSavingLead}
								inputProps={{ maxLength: 30 }}
							/>
						}
					/>
				</Grid>

				<Grid item xs={12} sm={4}>
					<LabeledFormInput
						label={thirdInputLabel}
						formInput={
							<SimpleTextField
								editable
								outlined
								text={getContextValue("customer", "thirdInputName")}
								placeholder={thirdInputLabel}
								classes={getContextError("customer", "thirdInputName") ? REQUIRED_FIELD_CLASSES : ""}
								error={getContextError("customer", "thirdInputName")}
								onFocusOut={(value = "") => onChangeContext<string>("customer", "thirdInputName", value)}
								disabled={isSavingLead}
								inputProps={{ maxLength: 30 }}
							/>
						}
					/>
				</Grid>
			</Grid>
		</Box>
	);
}

export default CustomerNameSection;
